module.exports = __webpack_public_path__ + "img/side-icon-22.00f15309.svg";